import IconSilhouette from 'asset/icon-silhouette.svg'
import { clsx } from 'clsx'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import css from './OutfitsPreview.module.scss'

const SLOTS = [1, 0, 2]

export const OutfitsPreview = observer(() => {
  const { outfits } = useDemo().outfitsPreview

  return <span className={css.preview}>
    {SLOTS.map(index => {
      const src = outfits[index]
      return <span key={index} className={clsx(css.card, index === 0 && css.center)}>
        {src
          ? <img className={css.image} src={src} alt="" loading="lazy" />
          : <IconSilhouette className={css.silhouette} />}
      </span>
    })}
  </span>
})
